<template>
  <div class="task-container">
    <div v-if="loading" class="w-100 h-100 d-flex justify-content-center align-items-center text-center mt-3">
      <div class="spinner-border text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    
    <div v-if="(!loading && !task)"
         class="d-flex flex-column justify-content-center align-items-center vh-100 ">
      <p><i class="fas fa-info-circle fa-5x text-gray"></i></p>
      <p class="text-gray">Seleccione una tarea en la lista de tareas</p>
    </div>
    
    <div v-if="task && !loading" class="task-body">
      <header class="sidebar-header mt-3">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="#" @click="toggleSidebar"><i class="breadcrumb-icon fa fa-angle-left mr-2"></i>Regresar</a>
            </li>
          </ol>
        </nav>
        
        <p class="py-2 px-3 m-0" v-if="task.classification"><strong class="mr-2">Tipo de tarea: </strong>{{ task.classification.title }}</p>
      </header>
      
      <div class="sidebar-section sidebar-section-fill px-sm-2 overflow-x-hidden">
        <component :is="currentTask"
                   v-bind="currentBindings"
                   @close-task="closeTask"
                   @show-component="showComponent"></component>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import ProtocolInvite from '../protocols/ProtocolInvite'
  import AmendmentProtocolInvite from '../amendments/AmendmentProtocolInvite'
  import LineLeaderEvaluation from '../protocols/LineLeaderEvaluation'
  import CenterDirectorEvaluation from '../protocols/CenterDirectorEvaluation'
  import CommitteeDictum from '../protocols/CommitteeDictum'
  import ProtocolEvaluation from '../protocols/ProtocolEvaluation'
  import ProtocolConditioned from '../protocols/ProtocolConditioned'
  import ProtocolFinalReportEvaluation from '../protocols/ProtocolFinalReportEvaluation'
  import ProtocolFinalReportNotApproved from '../protocols/ProtocolFinalReportNotApproved'
  import ReviewerInvite from '../protocols/ReviewerInvite'
  import ProtocolDevelopmentRequest from '../protocols/ProtocolDevelopmentRequest'
  import ApproveProtocolDevelopmentRequest from '../protocols/ApproveProtocolDevelopmentRequest'
  import AmendmentTitle from '../amendments/AmendmentTitle'
  import AmendmentProtocol from '../amendments/AmendmentProtocol'
  import AmendmentCancellation from '../amendments/AmendmentCancellation'
  import AmendmentExtension from '../amendments/AmendmentExtension'
  import AmendmentResponsible from '../amendments/AmendmentResponsible'
  import AmendmentResearchers from '../amendments/AmendmentResearchers'
  import CommitteeDictumAmendment from '../protocols/CommitteeDictumAmendment'
  import ReviewerAmendmentInvite from '../protocols/ReviewerAmendmentInvite'
  import EthicsRenewal from '../protocols/EthicsRenewal'
  import EthicsRenewalApproval from '../protocols/EthicsRenewalApproval'
  import ValidateArticle from '../articles/ValidateArticle'
  import ValidateBookChapter from '../books-chapters/ValidateBookChapter'
  import ValidatePresentation from '../presentations/ValidatePresentation'
  import AmendmentConditioned from '../amendments/AmendmentConditioned'
  import DeleteCommitment from '../protocols/DeleteCommitment'
  import RequestDeleteCommitment from '../protocols/RequestDeleteCommitment'
  
  export default {
    name: 'Task',
    components: {
      ProtocolInvite,
      LineLeaderEvaluation,
      CenterDirectorEvaluation,
      CommitteeDictum,
      ProtocolEvaluation,
      ProtocolConditioned,
      ProtocolFinalReportEvaluation,
      ProtocolFinalReportNotApproved,
      ReviewerInvite,
      ProtocolDevelopmentRequest,
      ApproveProtocolDevelopmentRequest,
      AmendmentTitle,
      AmendmentProtocol,
      AmendmentCancellation,
      AmendmentExtension,
      AmendmentResponsible,
      AmendmentResearchers,
      AmendmentConditioned,
      AmendmentProtocolInvite,
      CommitteeDictumAmendment,
      ReviewerAmendmentInvite,
      EthicsRenewal,
      EthicsRenewalApproval,
      ValidateArticle,
      ValidateBookChapter,
      ValidatePresentation,
      DeleteCommitment,
      RequestDeleteCommitment,
    },
    props: {
      task: Object,
      readonly: Boolean,
    },
    data: vm => ({
      loading: false,
      currentTask: null,
      currentBindings: {},
      classifications: {
        'participa_protocolo_investigador': 'ProtocolInvite',
        'participa_protocolo_investigador_enmienda': 'AmendmentProtocolInvite',
        'evaluar_protocolo_lider': 'LineLeaderEvaluation',
        'evaluar_protocolo_director': 'CenterDirectorEvaluation',
        'dictamen_comite_etica': 'CommitteeDictum',
        'dictamen_comite_bioseguridad': 'CommitteeDictum',
        'dictamen_comite_investigacion': 'CommitteeDictum',
        'dictamen_etica_condicionado_cambios_mayores': 'ProtocolConditioned',
        'dictamen_etica_condicionado_cambios_menores': 'ProtocolConditioned',
        'dictamen_etica_no_dictaminado': 'ProtocolConditioned',
        'dictamen_etica_aprobado_etapas': 'ProtocolConditioned',
        'dictamen_bioseguridad_condicionado_cambios_mayores': 'ProtocolConditioned',
        'dictamen_bioseguridad_condicionado_cambios_menores': 'ProtocolConditioned',
        'dictamen_bioseguridad_no_dictaminado': 'ProtocolConditioned',
        'dictamen_bioseguridad_aprobado_etapas': 'ProtocolConditioned',
        'dictamen_investigacion_condicionado_cambios_mayores': 'ProtocolConditioned',
        'dictamen_investigacion_condicionado_cambios_menores': 'ProtocolConditioned',
        'dictamen_investigacion_no_dictaminado': 'ProtocolConditioned',
        'dictamen_investigacion_aprobado_etapas': 'ProtocolConditioned',
        'protocolo_no_aprobado_lider': 'ProtocolEvaluation',
        'protocolo_no_aprobado_director': 'ProtocolEvaluation',
        'participa_protocolo_por_etica': 'ReviewerInvite',
        'participa_protocolo_por_bioseguridad': 'ReviewerInvite',
        'participa_protocolo_por_investigacion': 'ReviewerInvite',
        'dictamen_revisor_comite_investigacion': 'ReviewerInvite',
        'dictamen_revisor_comite_etica': 'ReviewerInvite',
        'dictamen_revisor_comite_bioseguridad': 'ReviewerInvite',
        'protocolo_solicitado_desarrollo': 'ProtocolDevelopmentRequest',
        'aprobacion_protocolo_solicitado_desarrollo': 'ApproveProtocolDevelopmentRequest',
        'informe_final_espera_revision_secretario': 'ProtocolFinalReportEvaluation',
        'protocolo_informe_final_espera_revision': 'ProtocolFinalReportEvaluation',
        'informe_final_espera_revision_comite': 'ProtocolFinalReportEvaluation',
        'protocolo_informe_final_no_aprobado': 'ProtocolFinalReportNotApproved',
        'informe_final_no_aprobado_comite': 'ProtocolFinalReportNotApproved',
        'informe_final_no_aprobado_secretario': 'ProtocolFinalReportNotApproved',
        
        /**
         * Amendments.
         */
        'enmienda_cambio_titulo': 'AmendmentTitle',
        'enmienda_protocolo': 'AmendmentProtocol',
        'enmienda_cancelacion_proyecto': 'AmendmentCancellation',
        'enmienda_prorroga': 'AmendmentExtension',
        'enmienda_investigador_responsable': 'AmendmentResponsible',
        'enmienda_coinvestigadores': 'AmendmentResearchers',
        /**
         * Amendments dictums.
         */
        // Change title amendment dictum.
        'enmienda_cambio_titulo_dictamen_investigacion': 'CommitteeDictumAmendment',
        'enmienda_cambio_titulo_dictamen_etica': 'CommitteeDictumAmendment',
        'enmienda_cambio_titulo_dictamen_bioseguridad': 'CommitteeDictumAmendment',
        
        // Protocol amendment.
        'enmienda_protocolo_dictamen_etica': 'CommitteeDictumAmendment',
        'enmienda_protocolo_dictamen_bioseguridad': 'CommitteeDictumAmendment',
        'enmienda_protocolo_dictamen_investigacion': 'CommitteeDictumAmendment',
        
        // Extension amendment.
        'enmienda_prorroga_dictamen_investigacion': 'CommitteeDictumAmendment',
        
        // Cancellation amendment.
        'enmienda_cancelacion_proyecto_dictamen_etica': 'CommitteeDictumAmendment',
        'enmienda_cancelacion_proyecto_dictamen_bioseguridad': 'CommitteeDictumAmendment',
        'enmienda_cancelacion_proyecto_dictamen_investigacion': 'CommitteeDictumAmendment',
        
        // Responsible researcher amendment.
        'enmienda_investigador_responsable_dictamen_etica': 'CommitteeDictumAmendment',
        'enmienda_investigador_responsable_dictamen_bioseguridad': 'CommitteeDictumAmendment',
        'enmienda_investigador_responsable_dictamen_investigacion': 'CommitteeDictumAmendment',
        
        // Researchers amendment.
        'enmienda_coinvestigadores_dictamen_etica': 'CommitteeDictumAmendment',
        'enmienda_coinvestigadores_dictamen_bioseguridad': 'CommitteeDictumAmendment',
        'enmienda_coinvestigadores_dictamen_investigacion': 'CommitteeDictumAmendment',
        
        // Amendments reviewers
        'participa_enmienda_por_investigacion': 'ReviewerAmendmentInvite',
        'participa_enmienda_por_etica': 'ReviewerAmendmentInvite',
        'participa_enmienda_por_bioseguridad': 'ReviewerAmendmentInvite',
        'dictamen_revisor_enmienda_por_investigacion': 'ReviewerAmendmentInvite',
        'dictamen_revisor_enmienda_por_etica': 'ReviewerAmendmentInvite',
        'dictamen_revisor_enmienda_por_bioseguridad': 'ReviewerAmendmentInvite',
  
        // Ethics renewal.
        'renovacion_anual_etica': 'EthicsRenewal',
        'renovacion_anual_etica_condicionada': 'EthicsRenewal',
        'renovacion_anual_etica_aprobacion': 'EthicsRenewalApproval',
        
        // Curriculum.
        'revision_articulo_subdirector_academico': 'ValidateArticle',
        'revision_articulo_comite_investigacion': 'ValidateArticle',
        'revision_libro_subdirector_academico': 'ValidateBookChapter',
        'revision_libro_comite_investigacion': 'ValidateBookChapter',
        'revision_ponencia_subdirector_academico': 'ValidatePresentation',
        'revision_ponencia_comite_investigacion': 'ValidatePresentation',

        // Commitments
        'solicitud_eliminar_compromiso': 'DeleteCommitment',
        'solicitud_eliminar_compromiso_condicionada': 'RequestDeleteCommitment',
      },
    }),
    methods: {
      toggleSidebar () {
        Looper.toggleSidebar()
      },
      closeTask () {
        this.currentTask     = null
        this.currentBindings = {}
        
        this.$emit('task-closed', this.task)
      },
      showComponent (component, bindings = null) {
        const types = {
          'cambio_titulo': 'AmendmentTitle',
          'investigador_responsable': 'AmendmentResponsible',
          'coinvestigadores': 'AmendmentResearchers',
          'prorroga': 'AmendmentExtension',
          'cancelacion_proyecto': 'AmendmentCancellation',
          'protocolo': 'AmendmentProtocol',
        }
        
        this.currentTask = types[component]
        
        if (bindings) {
          this.currentBindings = bindings
        }
      },
    },
    computed: {
      ...mapGetters(['user']),
    },
    watch: {
      task (task) {
        this.currentBindings = {
          user: this.user,
          task: task,
          readonly: this.readonly,
        }
        
        if (task) {
          this.currentTask = this.classifications[task.classification.key]
          
          if (task.protocol) {
            this.currentBindings = {
              ...this.currentBindings,
              protocol: task.protocol,
            }
          }
          
          if (task.committee) {
            this.currentBindings = {
              ...this.currentBindings,
              committee: task.committee,
            }
          }
          
          if (task.amendment) {
            this.currentBindings = {
              ...this.currentBindings,
              protocol: task.protocol,
              amendment: task.amendment,
              committee: task.committee ? task.committee : null,
            }
            
            // TODO: Change to regexp.rout
            if (task.classification.key === 'dictamen_enmienda_investigacion_condicionado' ||
              task.classification.key === 'dictamen_enmienda_etica_condicionado' ||
              task.classification.key === 'dictamen_enmienda_bioseguridad_condicionado' ||
              task.classification.key === 'dictamen_enmienda_etica_no_aprobado') {
              this.currentTask = 'AmendmentConditioned'
            }
          }
        }
      },
    },
  }
</script>
